import { Tooltip, TooltipPosition } from '@tableau/widgets';
import React, { ReactElement } from 'react';

import { ExtractEncryptionMode } from '~src/commonInfra/utils/sites/SitePropertyTypes';
import { IUpdateSiteSettingsForSiteAdminParams, UpdateSiteSettingsForSiteAdminRequest } from '~src/settings/ServerApi/requests/siteSettings/UpdateSiteSettingsForSiteAdminRequest';
import { ISiteAdminSettings, ISiteSettingsForSiteAdmin } from '~src/settings/types/ISiteSettingsForSiteAdmin';

import { tooltipCellStyle } from '../styles/CredentialEncryptionSettingsStyles';

export function formatDate(dateStr: string): string {
    const date = new Date(dateStr);
    if (dateStr === null || dateStr === undefined || isNaN(date.getTime())) {
      return '';
    }

    const options: Intl.DateTimeFormatOptions = {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    };
    return date.toLocaleString(undefined, options);
}

export function getTooltip(value: string): ReactElement<Tooltip> {
    return (
      <Tooltip
          position={TooltipPosition.Bottom}
          afterDelay={true}
          tooltipContent={value}
          onlyShowWhenClipped={true}
        >
          <div style={tooltipCellStyle}>{value}</div>
      </Tooltip>
    );
  }

export function getEnableEkmCredRequest(siteSettings: ISiteSettingsForSiteAdmin): UpdateSiteSettingsForSiteAdminRequest {
    const siteAdminSettings = siteSettings.siteAdminSettings as ISiteAdminSettings;

    return new UpdateSiteSettingsForSiteAdminRequest(
        {
            id: (siteSettings as any).id,
            siteAdminSettings: {
                ...siteAdminSettings,
                extractEncryptionMode: ExtractEncryptionMode.ENFORCED,
                siteSettingsV2: {
                    ekmCredEnabled: true
                }
            },
            subscriptionSettings: siteSettings.subscriptionSettings
        } as IUpdateSiteSettingsForSiteAdminParams);
}

export function capitalizeFirstLetter(input: string): string {
    if (!input || input.length === 0) {
        return input;
    }

    if (input === 'INACTIVE') {
      input = 'DEACTIVATED';
    }

    return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
}